import { reportError } from '@/lib/errors'

/** Last resort for exceptions outside React and the request/mutation boundaries. */
export function installBrowserErrorReporting() {
  const onError = (event: ErrorEvent) => reportError(event.error, { operation: 'Unexpected browser error' })
  const onRejection = (event: PromiseRejectionEvent) =>
    reportError(event.reason, { operation: 'Unhandled asynchronous action' })
  window.addEventListener('error', onError)
  window.addEventListener('unhandledrejection', onRejection)
  return () => {
    window.removeEventListener('error', onError)
    window.removeEventListener('unhandledrejection', onRejection)
  }
}
